module.exports = __webpack_public_path__ + "static/media/postgresql.82cbafe0.png";